import { select } from 'redux-saga/effects';
import { RootState } from '../../../../core/redux/store';
import { SheetsCommand } from '../../../types/commands/common';
import { SheetCommandType } from '../../../types/commands/sheetCommands/sheetCommands';
import { SheetGroupsCommandType } from '../../../types/commands/sheetGroupsCommands/sheetGroupCommands';
import { SheetManagementSet } from '../../../types/sheet/draft';
import { v4 as uuid } from 'uuid';
import {
  addSheetToGroup,
  createSheetGroup,
  deleteSheetGroup,
  removeSheetFromGroup,
} from './sheetGroupCRUD';
import { createSheet, deleteSheet } from './sheetCRUD';
import { executeGridCommand } from './executeGridCommand';
import { showErrorToast } from '../../../../core/utils/view/toast';
import { executeCellCommand } from './executeCellCommand';

export async function executeSheetsCommand(
  set: SheetManagementSet,
  command: SheetsCommand
) {
  switch (command.type) {
    case SheetGroupsCommandType.AddSheetToGroup:
      await addSheetToGroup(set, command);
      break;
    case SheetGroupsCommandType.RemoveSheetFromGroup:
      await removeSheetFromGroup(set, command);
      break;
    case SheetGroupsCommandType.RenameGroup:
      break;
    case SheetGroupsCommandType.CreateGroup:
      await createSheetGroup(set, command);
      break;
    case SheetGroupsCommandType.DeleteGroup:
      await deleteSheetGroup(set, command);
      break;
    case SheetCommandType.CreateSheet:
      await createSheet(set, command);
      break;
    case SheetCommandType.DeleteSheet:
      await deleteSheet(set, command);
      break;
    case SheetCommandType.HideGrid:
    case SheetCommandType.UnhideGrid:
    case SheetCommandType.FreezeGrid:
    case SheetCommandType.GroupGrid:
    case SheetCommandType.UngroupGrid:
    case SheetCommandType.ResizeGrid:
      await executeGridCommand(set, command);
      break;
    case SheetCommandType.CellInput:
    case SheetCommandType.NumberFormat:
    case SheetCommandType.Styles:
    case SheetCommandType.ApplyDataValidation:
    case SheetCommandType.RemoveDataValidation:
      await executeCellCommand(set, command);
  }
}
